import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable */

const XMobileNavigationView = ({ hide, onClick }) =>
  hide ? null : (
    <div onClick={onClick} role="button" className="adv-workflow-mobile-x">
      +
    </div>
  );
XMobileNavigationView.propTypes = {
  hide: PropTypes.bool.isRequired,
};

export default XMobileNavigationView;
